import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, map, tap, catchError, finalize } from 'rxjs/operators';
import { InvestigationTypeRepository } from '../../../infrastructure/repositories/investigation-type.repository';
import { InvestigationTypeState } from '../../states/investigation-type.state';
import { CreateInvestigationTypeCommand } from './create-investigation-type.command';
import { CreateInvestigationTypeResult } from './create-investigation-type.result';

@Injectable({ providedIn: 'root' })
export class CreateInvestigationTypeUseCase {
  private readonly _repository = inject(InvestigationTypeRepository);
  private readonly _state = inject(InvestigationTypeState);

  public execute(command: CreateInvestigationTypeCommand): Observable<CreateInvestigationTypeResult> {
    this._state.setSaving(true);
    this._state.clearError();

    return this._repository.createInvestigationType(command).pipe(
      switchMap((result) =>
        this._repository.getAllInvestigationTypes().pipe(
          tap((investigationTypes) => this._state.setInvestigationTypes(investigationTypes)),
          map(() => ({ id: result.id })),
        ),
      ),
      catchError((error) => {
        throw error;
      }),
      finalize(() => this._state.setSaving(false)),
    );
  }
}
